module.exports = __webpack_public_path__ + "img/hotel-olissippo-saldanha.0036e8df.jpg";